import { provider } from './provider'
// -------------------------------------
// Provide array of keys for questions
// -------------------------------------
export function questions( { drugs, rules, faqs } ) {

  // Uncomment to disable questions
  // return []
  const xeon = { drugs, rules, faqs }
  const data = provider( xeon )
  // --------------------------------------------------
  // Count critera { mild: [], moderate: [], strong: [], none: [] }
  // --------------------------------------------------
  const crits = data.subgroup( xeon )

  if ( data.danger( crits ) < 3 ) {
    return []
  }

  // Check rules for questions and don't add twice
  const missing = {}
  // -----------------------------------------------
  // Find questions to be asked by iterating rules
  // -----------------------------------------------
  for ( const id of Object.keys( blueprint ) ) {
    for ( const key of Object.keys( blueprint[ id ] ) ) {
      // Check for preexisitng question request
      if ( !faqs[ id ] || !faqs[ id ][ key ] ) {
        missing[ `${id}.${key}` ] = true
      }
    }
  }

  return Object.keys( missing )
}

// -------------------------------------------
// From findings in questions:anticholinergic
// -------------------------------------------
export const blueprint = {}